// extracted by mini-css-extract-plugin
export var createdDate = "_mr-1";
export var divider = "_mr-2";
export var headerDivider = "_mr-3";
export var messagesCard = "_mr-0";
export var messagesContainer = "_mr-6";
export var messagesContainerWrapper = "_mr-4";
export var showLeftPanelButton = "_mr-8";
export var topButtons = "_mr-7";
export var withPadding = "_mr-5";